"use strict";

exports.__esModule = true;
exports["default"] = nextMode;

function nextMode(mode) {
  if (mode === 'month') {
    return 'year';
  }

  return 'month';
}